export const propertyProductsConstants = {
    PROPERTY_PRODUCTS_PENDING  : 'PROPERTY_PRODUCTS_PENDING',
    PROPERTY_PRODUCTS_FULFILLED: 'PROPERTY_PRODUCTS_FULFILLED',
    PROPERTY_PRODUCTS_REJECTED : 'PROPERTY_PRODUCTS_REJECTED',
};
